(function() {
    angular.module("app").factory("version", version)

    version.$inject = [
        // "$rootScope"
    ]

    function version() {

        "use strict"

        const _service = {}

        const getParameterVersion = (elementID) => {

            try {

                const element = document.getElementById(elementID)

                const regex = new RegExp("[?&]version(=([^&#]*)|&|#|$)")

                let results

                if (element.src !== undefined) {
                    results = regex.exec(element.src)
                } else {
                    results = regex.exec(element.href)
                }

                const version = Number(decodeURIComponent(results[2].replace(/\+/g, " ")))

                if (!isNaN(version) && version >= 0 && version <= 9999) {
                    return version
                }

            } catch(e) {
                // console.log(e)
            }

            return 0

        }

        _service.load = () => {

            const v = {
                code: {
                    app:      getParameterVersion("codeApp"),
                    vendor:   getParameterVersion("codeVendor"),
                    wmcanvas: getParameterVersion("codeWMCanvas")
                },
                style: {
                    app:    getParameterVersion("styleApp"),
                    vendor: getParameterVersion("styleVendor")
                }
            }

            console.log("[VERSION] "
                + v.code.app + "."
                + v.code.vendor + "."
                + v.code.wmcanvas + "."
                + v.style.app + "."
                + v.style.vendor
            )

            return v

        }

        return _service

    }
})()
